import {FACILITY_CATEGORY, PAYMENT_TYPE, RESERVATION_STATUS, RESERVATION_TYPE} from '../../CodeMaster'
import {Nullable} from '../../app/TypeHelpers'
import moment, {Moment} from 'moment'
import ReservationCardInformation, {ChargeInformation} from './ReservationCardInformation'

export default class AdditionalChargeCardInformation {
    facilityCategory: Nullable<FACILITY_CATEGORY>
    facilityName: Nullable<string>
    imageUrl: Nullable<string>
    facilityReserveId: number
    reserveStatus: RESERVATION_STATUS
    reserveTitle: string
    reserveCategory: RESERVATION_TYPE
    chargeInformations: ChargeInformation[]
    useDate: Moment

    constructor(
        facilityCategory: FACILITY_CATEGORY | null,
        facilityName: string | null,
        imageUrl: string | null,
        facilityReserveId: number,
        reserveStatus: RESERVATION_STATUS,
        reserveTitle: string,
        reserveCategory: RESERVATION_TYPE,
        chargeInformations: ChargeInformation[],
        useDate: moment.Moment,
    ) {
        this.facilityCategory = facilityCategory
        this.facilityName = facilityName
        this.imageUrl = imageUrl
        this.facilityReserveId = facilityReserveId
        this.reserveStatus = reserveStatus
        this.reserveTitle = reserveTitle
        this.reserveCategory = reserveCategory
        this.chargeInformations = chargeInformations
        this.useDate = useDate
    }

    static from(json: any): AdditionalChargeCardInformation {
        return new AdditionalChargeCardInformation(
            json.facilityCategory && FACILITY_CATEGORY.codeToEnumConstants(json.facilityCategory),
            json.facilityName,
            json.imageUrl,
            json.facilityReserveId,
            RESERVATION_STATUS.codeToEnumConstants(json.reserveStatus),
            json.reserveTitle,
            RESERVATION_TYPE.codeToEnumConstants(json.reserveCategory),
            json.chargeInformations.map((chargeInfo: any) => ({
                charge: chargeInfo.charge,
                paymentMethod: PAYMENT_TYPE.codeToEnumConstants(chargeInfo.paymentMethod),
            })),
            moment(json.reserveStartDatetime),
        )
    }
}

export function convertJsonToCardInformation(json: any): ReservationStatusCardInformation {
    if (json.reserveCategory === RESERVATION_TYPE.ADDITIONAL_CHARGE.value) {
        return AdditionalChargeCardInformation.from(json)
    } else {
        return ReservationCardInformation.from(json)
    }
}

export type ReservationStatusCardInformation = ReservationCardInformation | AdditionalChargeCardInformation
